import type { INavigationGroup, INavigationItem, NavigationLevel } from '@workspace/interfaces/header';

export const isNavigationGroup = (item: INavigationItem | INavigationGroup): item is INavigationGroup =>
  (item as INavigationGroup)._type === 'navigationGroup';

export const resetToRootLevel = (items: (INavigationItem | INavigationGroup)[]): NavigationLevel[] => [
  { title: 'Menu', items },
];
